import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitInquiry = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);

export const adminHeaders = (token) => ({ "X-Admin-Token": token });

export const verifyAdmin = (token) =>
  api.post("/admin/verify", null, { headers: adminHeaders(token) }).then((r) => r.data);

export const fetchInquiries = (token) =>
  api.get("/admin/inquiries", { headers: adminHeaders(token) }).then((r) => r.data);

export const fetchStats = (token) =>
  api.get("/admin/stats", { headers: adminHeaders(token) }).then((r) => r.data);

export const updateInquiryStatus = (token, id, status) =>
  api
    .patch(`/admin/inquiries/${id}`, { status }, { headers: adminHeaders(token) })
    .then((r) => r.data);

export const deleteInquiry = (token, id) =>
  api.delete(`/admin/inquiries/${id}`, { headers: adminHeaders(token) }).then((r) => r.data);
